// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	GUILD_BOOST_LEVEL_THRESHOLDS,
	type GuildBoostLevel,
	resolveEffectiveGuildBoostLevel,
} from '@fluxer/constants/src/GuildBoostConstants';

export interface GuildBoostSidebarProgress {
	readonly level: GuildBoostLevel;
	readonly count: number;
	readonly currentRequired: number;
	readonly nextRequired: number | null;
	readonly ratio: number;
	readonly isMaxLevel: boolean;
}

export function resolveGuildBoostSidebarProgress(guild: {
	premiumTier: number;
	premiumSubscriptionCount: number;
}): GuildBoostSidebarProgress {
	const count = Number.isFinite(guild.premiumSubscriptionCount)
		? Math.max(0, Math.floor(guild.premiumSubscriptionCount))
		: 0;
	const level = resolveEffectiveGuildBoostLevel({
		boostCount: count,
		boostLevelOverride: guild.premiumTier,
	});
	const isMaxLevel = level >= 3;
	const nextRequired = isMaxLevel ? null : GUILD_BOOST_LEVEL_THRESHOLDS[(level + 1) as 1 | 2 | 3];
	const currentRequired = level === 0 ? 0 : GUILD_BOOST_LEVEL_THRESHOLDS[level];
	if (isMaxLevel || nextRequired == null) {
		return {level, count, currentRequired, nextRequired: null, ratio: 1, isMaxLevel: true};
	}
	const span = nextRequired - currentRequired;
	const ratio = span <= 0 ? 1 : Math.min(1, Math.max(0, (count - currentRequired) / span));
	return {level, count, currentRequired, nextRequired, ratio, isMaxLevel: false};
}
